import { render, staticRenderFns } from "./date-range.vue?vue&type=template&id=2edeafb6&scoped=true&"
import script from "./date-range.vue?vue&type=script&lang=ts&"
export * from "./date-range.vue?vue&type=script&lang=ts&"
import style0 from "./date-range.vue?vue&type=style&index=0&id=2edeafb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edeafb6",
  null
  
)

export default component.exports